export default __webpack_public_path__ + "static/media/golden.26d46f74.webp";